import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Device, DeviceInfo } from '@capacitor/device';
import { environment } from '../../../../environments/environment';
import { DactechDeviceInfo } from './device.model';

@Injectable({ providedIn: 'root' })
export class DeviceServices {
  private deviceId: any;
  private infos: DactechDeviceInfo;

  constructor(private platform: Platform) {
    this.platform.ready().then(() => {
      this.setDeviceId();
      this.setInfos();
    });
  }

  getInfos(): DactechDeviceInfo {
    return this.infos;
  }

  async setInfos() {
    const info: DeviceInfo = await Device.getInfo();
    this.infos = {
      // Version Android
      // Permet de voir la version android du téléphone du technicien
      // Je veux suivre la bonne mise à jour du téléphone du technicien
      device_os_version: info.osVersion,

      // Version de D@c Tech
      // Permet de voir la dernière version
      // Je veux suivre la bonne mise à jour de l'application et ainsi cibler les relances auprès des collaborateurs qui n'auraient pas les bonnes versions
      device_app_version: environment.appVersion,

      // Marque téléphone
      // Permet de suivre le parc mobile de D@c Tech et d'identifier des anomalies liées à un mobile
      // Je veux suivre le parc mobile utilisée avec D@C Tech et ainsi voir s'il y a des problèmes sur certains types de modèles.
      device_manufacturer: info.manufacturer,

      // Modèle téléphone utilisée
      // Permet de suivre le parc mobile de D@c Tech et d'identifier des anomalies liées à un mobile
      // Je veux suivre le parc mobile utilisée avec D@C Tech et ainsi voir s'il y a des problèmes sur certains types de modèles.
      device_model: info.model,
      date_creation: new Date().toISOString(),
    };
  }

  /* -------------- HANDLE USER DB -------------- */

  /**
   * Récupération de l'identifiant du téléphone
   */
  getDeviceId() {
    return this.deviceId;
  }

  /**
   * Enregistrement de l'identifiant du téléphone
   */
  async setDeviceId() {
    let deviceId = await Device.getId();
    if (deviceId && deviceId.identifier) {
      this.deviceId = deviceId.identifier;
    } else {
      this.deviceId = this.getRandomToken();
    }
  }

  /**
   * Génération d'un identifiant pour le téléphone sur on n'est sur navigateur web
   */
  getRandomToken() {
    return 'web_' + (Math.random() + 1).toString(36).substring(2);
  }
}
